<template>
  <div
    v-if="data.items && data.items.length > 0"
    :id="data.id"
    class="bg-gray-lighten3 pb-[5rem] pt-14 md:pb-[6rem]"
  >
    <div class="container">
      <div
        class="title text-center text-3xl uppercase text-slate md:text-5xl xl:text-6xl"
      >
        {{ $t('latest_news') }}
      </div>

      <div
        v-if="allTags.length"
        class="mt-4 flex flex-wrap justify-center gap-2"
      >
        <UiTag
          v-for="(tag, ti) in allTags"
          :key="ti"
          :active="activeTag === tag"
          @click="selectTag(tag)"
        >
          <span v-html="tag" />
        </UiTag>
      </div>

      <swiper-container ref="swiperEl" init="false" class="mt-12 pb-11">
        <swiper-slide v-for="(item, i) in visibleNews" :key="i">
          <NewsItem v-bind="item" />
        </swiper-slide>

        <div slot="container-end" class="swiper-scrollbar"></div>
      </swiper-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from 'vue';
import NewsItem from '~/components/sections/newsSection/NewsItem.vue';
import { useSwiperElement } from '~/composables';

const ALL_TAGS = 'All tags';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);

const activeTag = ref(ALL_TAGS);

const visibleNews = computed(() =>
  activeTag.value === ALL_TAGS
    ? props.data.items
    : props.data?.items?.filter((item: any) =>
        item.tags?.includes(activeTag.value),
      ),
);

const allTags = computed<string[]>(() => {
  const tags = [
    ...new Set(
      props.data?.items
        ?.map((item: any) => item.tags ?? [])
        .flat()
        .filter(Boolean),
    ),
  ] as string[];

  if (tags.length) tags.unshift(ALL_TAGS);
  return tags;
});

watch(visibleNews, () => {
  nextTick(() => swiperEl.value?.swiper?.update());
});

const selectTag = (tag: string) => {
  activeTag.value = activeTag.value === tag ? ALL_TAGS : tag;
};
</script>
